function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = React.createElement("path", {
  fill: "#004152",
  fillRule: "evenodd",
  d: "M5.412 3.429c.295-.18.481-.45.559-.81.077-.36.024-.709-.16-1.045L8.4 0l2.753 5.016-.972 1.991-1.94-3.585-4.046 2.473 3.434 6.346-1.061 2.175L1.095 4.44l2.591-1.574c.184.335.444.558.78.668.335.11.65.074.946-.105zm2.706.967L9.864 7.66 7.947 11.59 5.09 6.251l3.028-1.855zm9.214 1.874c-.343.135-.674.125-.993-.03-.32-.156-.531-.41-.635-.764-.105-.354-.072-.705.099-1.055L13 3.054l-7.36 15.09 2.803 1.368c.17-.35.427-.592.77-.727.342-.136.673-.126.992.03.32.155.531.41.636.764.104.353.07.705-.1 1.054L13.544 22l7.36-15.09-2.802-1.367c-.17.349-.428.591-.77.727zm-7.698 9.726l3.296 1.608 4.132-8.472-3.296-1.607-4.132 8.471zm-.894.438l4.821-9.883 4.395 2.143-4.82 9.884-4.396-2.144z",
  clipRule: "evenodd"
});

var SvgTickets = function SvgTickets(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTickets, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tickets.3be9aab6.svg";
export { ForwardRef as ReactComponent };